var map = {
	"./de-CH/config.json": 79933,
	"./de/config.json": 28417,
	"./en-GB/config.json": 23667,
	"./en/config.json": 11401,
	"./es/config.json": 17212,
	"./fr-CA/config.json": 20995,
	"./fr-CH/config.json": 1738,
	"./fr/config.json": 37748,
	"./it-CH/config.json": 16835,
	"./it/config.json": 37295,
	"./ja/config.json": 15203,
	"./ro/config.json": 99069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97991;